module.exports = __webpack_public_path__ + "img/34.6.CODm.83aa9e1e.png";